import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import {
    LOADING,
    GET_CENTRAL_ORDERS_LOG_SUCCESS,
    GET_BRAND_AND_REST_NAMES
} from '../types';
import { CHAIN_ADMIN } from '../../utils/Constants';
import MessageUtils from '../../utils/MessageUtils';

export const getOrdersCentral = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        let userRole = getState().user.role;
        let updatedSearchQuery = { ...searchQuery };
        if (userRole === CHAIN_ADMIN) {
            updatedSearchQuery = { ...searchQuery, userID: getState().user.id };
        }

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `/order/central-search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => getOrdersCentralLogSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:orderHistoryActions.loadOrdersFailure')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const getOrdersCentralLogSuccess = (res, dispatch, getState) => {
    dispatch({ type: GET_CENTRAL_ORDERS_LOG_SUCCESS, payload: res.data });
    dispatch({ type: LOADING, payload: false });
}

export const downloadOrderData = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        let userRole = getState().user.role;
        let updatedSearchQuery = { ...searchQuery };
        if (userRole === CHAIN_ADMIN) {
            updatedSearchQuery = { ...searchQuery, userID: getState().user.id };
        }

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `/order/download-central-search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => {
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:notificationsActions.downloadStartedMsg'));

                // let blob = new Blob([res.data], { type: 'application/csv' });
                // let link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.download = `last_2000_orders_log.csv`;
                // link.click();i18n.t('actions:orderHistoryActions.downloadOrdersFailure')
            })
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, err.response.userMessage))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const getQueryParams = (pageNumber, searchQuery) => {
    const {
        brandName,
        restaurantName,
        customerName,
        customerEmail,
        customerPhone,
        orderId,
        orderDate,
        amount,
        paymentTypeId,
        orderTypeId,
        orderStatus,
        address,
        userID,
        brandNameData,
        restaurantNameData, 
        urgentOrder } = searchQuery;
    let pageParam = '',
        sizeParam = '',
        brandNameParam = '',
        restaurantNameParam = '',
        customerNameParam = '',
        customerEmailParam = '',
        customerPhoneParam = '',
        orderIdParam = '',
        orderDateParam = '',
        amountParam = '',
        paymentTypeIdParam = '', 
        orderTypeIdParam = '', 
        orderStatusParam = '', 
        addressParam = '', 
        userId = '',
        brandId = '',
        restaurantId = '',
        urgentOrderParam = '';
    pageParam = pageNumber;
    sizeParam = 10; // backend default 20

    if (brandName && !brandNameData) {
        brandNameParam = `&brandName=${brandName}`;
    }

    if (restaurantName && !restaurantNameData) {
        restaurantNameParam = `&restaurantName=${restaurantName}`;
    }

    if (customerName) {
        customerNameParam = `&customerName=${customerName}`;
    }

    if (customerEmail) {
        customerEmailParam = `&customerEmail=${customerEmail}`
    }

    if (customerPhone) {
        customerPhoneParam = `&customerPhone=${customerPhone}`;
    }

    if (orderId) {
        orderIdParam = `&orderId=${orderId}`;
    }

    if (orderDate && orderDate !== 'Invalid date') {
        orderDateParam = `&orderDate=${orderDate}`;
    }

    if (amount) {
        amountParam = `&amount=${amount}`;
    }

    if (paymentTypeId) {
        paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`;
    }

    if (orderTypeId) {
        orderTypeIdParam = `&orderTypeId=${orderTypeId}`;
    }

    if (orderStatus) {
        orderStatusParam = `&orderStatus=${orderStatus}`;
    }

    if (address) {
        addressParam = `&address=${address}`;
    }

    if (userID) {
        userId = `&userId=${userID}`;
    }

    if (brandNameData && brandNameData.brandName === brandName) {
        brandId = `&brandId=${brandNameData.brandId}`
    }

    if (restaurantNameData && restaurantNameData.restaurantName === restaurantName) {
        restaurantId = `&restaurantId=${restaurantNameData.restaurantId}`
    }

    if (urgentOrder) {
        urgentOrderParam = `&urgentOrder=${urgentOrder}`
    }

    return `page=${pageParam}&size=${sizeParam}${brandNameParam}${restaurantNameParam}${customerNameParam}${customerEmailParam}${customerPhoneParam}${orderIdParam}${orderDateParam}${amountParam}${paymentTypeIdParam}${orderTypeIdParam}${orderStatusParam}${addressParam}${userId}${brandId}${restaurantId}${urgentOrderParam}`;
}

export const getBrandAndRestNames = () => {
    return (dispatch) => {

        const url = `/restaurant-chain/names`;

        axios().get(url)
            .then(res => saveNamesSuccess(res.data, dispatch));
    }
}

const saveNamesSuccess = (resData, dispatch) => {
    dispatch({ type: GET_BRAND_AND_REST_NAMES, payload: resData });
}


// WEBPACK FOOTER //
// ./src/actions/central/CentralOrdersLogAction.js